import { styled } from '@mui/material';
import { Toolbar } from 'react-admin';

export const FormToolbar = styled(Toolbar)({
  boxSizing: 'border-box',
  justifyContent: 'space-between',
  width: '100%',
});
